import React from 'react';
import { APP_DOMAINS, APP_ROUTES_PERMISSIONS, OWNER_ROLES } from '~/types';
import { RouteObject, Navigate } from 'react-router-dom';
import {
  Chat,
  CollabDashboard,
  ConsumerStats,
  Campaings as Campaigns,
  Page404Screen,
  Settings,
  Training,
  Payments,
  Teams,
  OnboardingScreen,
  Schedule,
} from '~/components/screens';
import Integrations from '../screens/integrations';
import Store from '../screens/store';
import Customer from '../screens/Customer';
import Forms from '../screens/forms';

const domainComponentMap: Record<string, any> = {
  [APP_DOMAINS.CONVERSATIONS]: Chat,
  [APP_DOMAINS.COLLAB]: CollabDashboard,
  [APP_DOMAINS.CAMPAIGNS]: Campaigns,
  [APP_DOMAINS.STATS]: ConsumerStats,
  [APP_DOMAINS.SETTINGS]: Settings,
  [APP_DOMAINS.TRAINING]: Training,
  [APP_DOMAINS.AGENTS]: OnboardingScreen,
  [APP_DOMAINS.BILLING]: Payments,
  [APP_DOMAINS.TEAMS]: Teams,
  [APP_DOMAINS.INTEGRATIONS]: Integrations,
  [APP_DOMAINS.STORE]: Store,
  [APP_DOMAINS.SCHEDULE]: Schedule,
  [APP_DOMAINS.CUSTOMERS]: Customer,
  [APP_DOMAINS.FORMS]: Forms,

};

export const generateAuthRoutes = (agent: {
  _id: string;
  role: OWNER_ROLES;
  status: string;
  name: string;
}): RouteObject[] => {
  const accessibleDomains = Object.entries(APP_ROUTES_PERMISSIONS)
    .filter(([domain, permission]) => permission.roles.includes(agent.role))
    .map(([domain]) => domain as APP_DOMAINS);

  const domainRoutes: RouteObject[] = accessibleDomains.map((domain) => ({
    path: `${domain.toLowerCase()}/*`,
    // Ensure component exists before creating element
    element: domainComponentMap[domain] ? (
      React.createElement(domainComponentMap[domain])
    ) : (
      <Page404Screen />
    ),
  }));

  const defaultRoute =
    accessibleDomains.length > 0
      ? {
          index: true,
          element: (
            <Navigate to={`${accessibleDomains[0].toLowerCase()}`} replace />
          ),
        }
      : {
          index: true,
          element: <Page404Screen />,
        };

  const notFoundRoute: RouteObject = {
    path: '*',
    element: <Page404Screen />,
  };

  return [defaultRoute, ...domainRoutes, notFoundRoute];
};
